<style lang="scss" scoped>
@import '../../../sass/variables';

  .btn-cancel {
    color: $salesflow-font-gray;

    &:hover {
      color: $salesflow-primary-hover;
    }
  }
</style>

<template>
  <div>
    <button
      class="salesflow-btn salesflow-btn-small salesflow-btn-outline"
      @click="openModal()"
    >
      {{ __('Criar novo formulário') }}
    </button>
    <BModal
      id="modal-new-form"
      modal-class="modal-no-header-no-footer"
      ref="modal-new-form"
      hide-header="hide-header"
      hide-footer="hide-footer"
    >
      <template slot="default">
        <button
          class="close"
          type="button"
          aria-label="Close"
          @click="$refs['modal-new-form'].hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title align-items-center text-center">
          {{ __('Novo formulário') }}
          <h6 class="modal-subtitle">
            {{ __('Preencha os dados do novo formulário') }}
          </h6>
        </h4>
        <form
          class="px-20px"
          method="post"
          @submit.prevent="save()"
        >
          <div class="form-group">
            <label>{{ __('Nome do formulário') }}</label>
            <input
              class="name form-control"
              id="form"
              type="text"
              v-model="form.name"
              :placeholder="__('Digite aqui o nome do seu formulário')"
              required="required"
            >
          </div>
          <div class="form-group">
            <label>{{ __('Descrição') }}</label>
            <input
              class="form-control"
              type="textarea"
              v-model="form.description"
              :placeholder="__('Descrição do formulário (opcional)')"
            >
          </div>
          <p
            class="text-danger"
            v-if="error"
          >
            {{ error }}
          </p>
          <div class="modal-footer default-modal-footer">
            <div class="col-12">
              <div class="row text-center">
                <div class="col-12">
                  <button
                    class="btn btn-primary f-w-600"
                    type="submit"
                    :disabled="saving"
                  >
                    <i
                      class="fa fa-circle-o-notch fa-spin"
                      v-if="saving"
                    /><span v-else>{{ __('Continuar') }}</span>
                  </button>
                </div>
              </div>
              <div class="row text-center">
                <div class="col-12">
                  <button
                    class="btn btn-cancel f-w-500"
                    type="button"
                    aria-label="Close"
                    @click="$refs['modal-new-form'].hide()"
                  >
                    <u>{{ __('Cancelar') }}</u>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </template>
    </BModal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  props: {
    storepath: {
      type: String,
      required: true,
    },
  },

  data () {
    return {
      form: {
        name: null,
        description: null,
      },
      modules: [],
      types: false,
      error: null,
      saving: false,
    };
  },

  methods: {
    openModal () {
      this.$refs['modal-new-form'].show();

      setTimeout(() => {
        document.querySelector('#form.name').focus();
      }, 500);
    },

    save () {
      const form = { ...this.form };

      this.error = null;
      this.saving = true;

      this.$http.post(this.storePath, form)
        .then(({ data }) => {
          window.location = `/form/${data.id}`;
        })
        .catch((error) => {
          console.log(error);
          this.error = this.__('Preencha todos os campos');
          this.saving = false;
        });
    },
  },
};
</script>
